/** Utility functions for logging and debugging */
export class Dbg
{
  // use these, for now...

  static assert(condition, message) {
    console.assert(condition, message);
  }

  static log(message) {
    console.log(message);
  }

}



// WEBPACK FOOTER //
// ./src/util.js